<template>
<div class="chapter">
<div class="inner_page">
<p class="center" id="fm1">HONEST JOHN BULL</p>
<div class="block">
<p class="nonindent">Here’s a health to ‘Old honest John Bull’,<br/>When he’s gone we shan’t find such another;<br/>With hearts and with glasses brim full,<br/>We’ll drink to ‘Britania, his mother,’<br/>For she gave him a good education,<br/>Bade him keep to his God and his King,<br/>Be loyal and true to the nation,<br/>And then to get merry and sing.</p>
<p class="extract">For John is a good-natured fellow,<br/>Industrious, honest and brave;<br/>Not afraid of his better when mellow,<br/>For betters he knows he must have.<br/>There must be fine lords and fine ladies,<br/>There must be some little, some great;<br/>Their wealth the support of our trade is.<br/>Our trade the support of the State.</p>
<p class="extract">The plough and the loom would stand still,<br/>If we were made gentlefolks all;<br/>If clodhoppers—who then would fill<br/>The parliament, pulpit or hall?<br/>‘Rights of Man’ makes a very fine sound,<br/>‘Equal riches’ a plausible tale;<br/>Whose labourers would then till the ground?<br/>All would drink, but who’d brew the ale?</p>
<p class="extract">Half naked and starv’d in the streets,<br/>We would wander about, <em>sans culottes</em>;<br/><a id="page8"></a>Would Liberty find us in meats,<br/>Or Equality lengthen our coats?<br/>That knaves are for levelling, don’t wonder,<br/>We may easily guess at their views;<br/>Pray, who’d gain the most by the plunder?<br/>Why, they that have nothing to lose.<br/><br/></p>
<p class="right"><em>The Norfolk Minstrel</em></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780795310959_epub_fm1_r1.vue?4a50da2e